module.exports = __webpack_public_path__ + "static/media/private-event03.573b6412.jpg";